import { Node, mergeAttributes } from "@tiptap/core";

export default Node.create({
  name: "collection",

  priority: 1000,
  draggable: true,

  addOptions() {
    return {
      HTMLAttributes: {},
      tag: "article",
    };
  },

  group: "collection",

  content: "note{1,6}",

  parseHTML() {
    return [{ tag: "section", priority: 51 }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "article",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  /*
  addKeyboardShortcuts() {
    return {
      "": () => this.editor.commands.setParagraph(),
    };
  },
  */
});
